import { render, staticRenderFns } from "./DeleteOtherService.vue?vue&type=template&id=5f43d1d8&"
import script from "./DeleteOtherService.vue?vue&type=script&lang=js&"
export * from "./DeleteOtherService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports